import {useFormContext} from "react-hook-form";
import {useOfferingSchedules} from "@/features/availability";
import {SessionAvailabilityFormFieldType} from "../types";

/**
 * Names the selected schedule in the collapsed Availability header, as
 * "Selected schedule: Working hours".
 *
 * Deliberately the schedule name only, not its weekly hours: the hours live behind
 * `availability/schedule/:id`, which is fetched lazily when the coach actually opens the
 * section. Reading them here would add a request to every offering form load for
 * everyone who never opens it. The name comes from the list the form already holds, so
 * this costs nothing.
 */
export function SessionAvailabilityScheduleSummary() {
  const {watch} = useFormContext<SessionAvailabilityFormFieldType>();
  const scheduleId = watch("availabilityScheduleId");
  const {schedules} = useOfferingSchedules();

  const selectedSchedule = schedules.find((schedule) => schedule.id === scheduleId);

  // Say nothing rather than something reassuring while nothing is actually selected.
  if (!selectedSchedule) return null;

  // Labelled so the muted line reads as a chosen value rather than a description of the
  // section itself.
  return <>Selected schedule: {selectedSchedule.name}</>;
}
